
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/passenger-car",
      function () {
        return require("private-next-pages/rims/passenger-car.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/passenger-car"])
      });
    }
  